<template>
	<div
		:class="tableClasses"
	>
		<table>
			<thead>
				<tr>
					<th
						v-if="selectable && removeSelecteds === false"
						key="selectable"
						class="ink-base font-size-big align-left padding-left-big"
					>
						<BCheckbox v-model="allSelected" name="allSelected" />
					</th>
					<th
						v-if="selectable && removeSelecteds === true"
						key="selectable"
						class="ink-base font-size-big align-left padding-left-big"
					>
						<BCheckbox v-model="removeSelecteds" name="removeSelecteds" icon="remove" />
					</th>
					<th
						:class="{
							'padding-vertical-big': cellSize == 'big'
						}"
						class="ink-base font-size-xbig semi-bold align-left padding-horizontal-big padding-vertical-normal"
						v-for="{ key, value } in localFields"
						:key="key"
					>
						{{ value }}
					</th>
				</tr>
			</thead>
			<tbody v-if="items.length > 0">
				<tr
					v-for="item in items"
					:key="item._id"
					@mouseover="updateDisplayOnHover(item._id, 'over')"
					@mouseleave="updateDisplayOnHover(item._id, 'leave')"
				>
					<td
						v-if="selectable"
						key="selectable"
						class="ink-base font-size-big align-left padding-left-big padding-vertical-normal"
						:style="[{ 'border-color': item.borderColor ? item.borderColor : '#dcdbe1' }, { 'background': item.bgColor ? item.bgColor : '#fff' }]"
					>
						<BCheckbox
							v-if="item['selectable'] !== false"
							v-model="selectedsModel[item._id]"
							:name="item._id"
							@input="changeSelectedValue(item._id)"
						/>
						<BIcon class="blocked-select ink-lighter-3" v-else
							><icon-check-box-outline-blank
						/></BIcon>
					</td>
					<template v-for="{ key, showOnHover } in localFields">
						<td
							v-if="typeof $scopedSlots[key] !== 'undefined'"
							:class="{
								'padding-vertical-big': cellSize == 'big',
								'padding-horizontal-big': cellSize == 'big'
							}"
							class="ink-base font-size-big regular padding-horizontal-big padding-vertical-normal"
							:style="[{ 'border-color': item.borderColor ? item.borderColor : '#dcdbe1' }, { 'background': item.bgColor ? item.bgColor : '#fff' }]"
							:key="key"
						>
							<div
								:class="{'hidden': showOnHover && displayRowId !== item._id}"
							>
								<slot :name="key" :field="key" :item="item"></slot>
							</div>
						</td>
						<td
							v-else
							:class="{
								'padding-vertical-big': cellSize == 'big',
								'font-size-xbig': cellSize == 'big',
								'padding-horizontal-big': cellSize == 'big'
							}"
							class="ink-base font-size-big regular padding-horizontal-big padding-vertical-normal"
							:style="{ 'border-color': item.borderColor ? item.borderColor : '#dcdbe1' }"
							:key="key"
						>
							{{ item[key] }}
						</td>
					</template>
				</tr>
				<tr v-if="hasPagination">
					<td :colspan="localFields.length" class="pagination padding-tiny">
						<b-pagination :currentPage="currentPage" :pageCount="pageCount" @loadPage="loadPageTable" />
					</td>
				</tr>
			</tbody>
			<tbody v-else>
				<tr>
					<td
						class="ink-base font-size-big align-left padding-left-big padding-vertical-normal no-items"
						:colspan="selectable ? localFields.length + 1 : localFields.length"
					>
						<slot name="noitems"></slot>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import BPagination from './Pagination.vue';
import BCheckbox from './Checkbox.vue';
import BIcon from './Icon.vue';

export default {
	name: 'b-highlighted-lines-table',
	components: {
		BPagination,
		BCheckbox,
		BIcon
	},
	data: function() {
		return {
			allSelected: false,
			removeSelecteds: false,
			selectedsModel: {},
			selecteds: [],
			display: {},
			displayRowId: ''
		};
	},
	props: {
		/**
		 * Colunas da tabela
		 */
		fields: Array,
		/**
		 * Define quantidade de colunas vazias a serem inseridas, permitindo deslocar
		 * as colunas mais para esquerda
		 */
		spacing: Number,
		/**
		 * Dados da tabela
		 */
		items: Array,
		/**
		 * Número de páginas totais
		 */
		pageCount: Number,
		/**
		 * Número da página atual
		 */
		currentPage: Number,
		/**
		 * Se true, tabela terá opção de seleção de linhas
		 */
		selectable: Boolean,
		/**
		 * Tamanho da célula da tabela (big ou normal)
		 */
		cellSize: {
			type: String,
			default: 'normal'
		},
		/**
		 * Indica se a tabela tem ou não paginação
		 */
		hasPagination: {
			type: Boolean,
			default: false
		},
		/**
		 * Permite customização das classes da tabela
		 */
		tableClasses: {
			type: [String, Array],
			default:
				'margin-horizontal-auto table-width margin-horizontal-tiny margin-bottom-xbig display-flex flex-column '
		}
	},
	computed: {
		localFields() {

			if(this.spacing) {
				const localFields = [...this.fields];
				for (let index = 0; index < this.spacing; index++) {
					localFields.push({
						key: `empty${index}`,
						value: '',
						showOnHover: false
					})
				}

				return localFields;
			} else return this.fields
		}
	},
	methods: {
		cleanSelectable() {
			this.allSelected = false;
			this.removeSelecteds = false;
			this.selecteds = [];
			this.selectedsModel = {};
		},
		loadPageTable(page) {
			this.$emit('loadPageTable', page);
		},
		changeSelectedItems(selectedItems) {
			this.$emit('changeSelectedItems', selectedItems);
		},
		changeSelectedValue(elementId) {
			this.removeSelecteds = true;
			if (this.selecteds.includes(elementId)) {
				this.$set(this.selectedsModel, elementId, false);
				const index = this.selecteds.indexOf(elementId);
				this.selecteds.splice(index, 1);
				if (this.selecteds.length == 0) this.removeSelecteds = false;
			} else {
				this.$set(this.selectedsModel, elementId, true);
				this.selecteds.push(elementId);
				if (this.selecteds.length == this.items.length) {
					this.removeSelecteds = false;
					this.$nextTick(function() {
						this.allSelected = true;
					});
				}
			}
		},
		updateDisplayOnHover(rowId, overOrLeave) {
			if (overOrLeave == 'over') this.displayRowId = rowId;
			else this.displayRowId = '';
		}
	},
	watch: {
		allSelected: function(newStatus) {
			if (newStatus === true) {
				this.items.forEach(item => {
					if (item.selectable !== false) {
						if (!this.selecteds.includes(item._id)) this.selecteds.push(item._id);
						this.$set(this.selectedsModel, item._id, true);
					}
				});
			} else {
				this.selecteds = [];
				this.selectedsModel = {};
			}
			this.changeSelectedItems(this.selecteds);
		},
		removeSelecteds: function(newStatus) {
			if (newStatus === false) {
				this.selecteds = [];
				this.selectedsModel = {};
				this.allSelected = false;
			}
			this.changeSelectedItems(this.selecteds);
		},
		selectedsModel: function() {
			this.changeSelectedItems(this.selecteds);
		}
	}
};
</script>

<style lang="scss" scoped>
table {
	border-spacing: 0 0.8rem;
	border-collapse: separate;
}

table tbody tr {
	border-radius: 5px;
}

table tbody tr:hover {
	box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.16);
;
}

table td,
table th {
	background: #fff;
	border-top: 1px solid #dcdbe1;
	border-bottom: 1px solid #dcdbe1;
}

table td:first-child,
table th:first-child {
	border-radius: 5px 0 0 5px;
	border-left: 1px solid #dcdbe1;
}

table td:last-child,
table th:last-child {
	border-radius: 0 5px 5px 0;
	border-right: 1px solid #dcdbe1;
}

table td.pagination {
	border-radius: 5px;
	border-right: 1px solid #dcdbe1;
}

div.table-box {
	auto > div {
		width: auto;
	}
}

.blocked-select {
	font-size: 2rem;
}

table td.no-items {
	border-radius: 5px;
}

table td {
	visibility: 'visible';
	@media (min-width: 996px) {
		.hidden {
			visibility: hidden;
		}
	}
}

@media (min-width: 1200px) {
	.table-width {
		width: 100%;
	}
}
</style>
